import { useSyncedRef } from "@react-hookz/web";
import { useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { useLatest } from "react-use";

import { useCanonicalUrl } from "shared/hooks";

import type { TrackPageViewFunction } from "scmp-app/components/tracking/atoms";
import { trackingAtom } from "scmp-app/components/tracking/atoms";
import * as gtm from "scmp-app/components/tracking/google-tag-manager/apis";
import { useIsAutoRefreshed } from "scmp-app/lib/hooks";

export const useTrackingSetup = () => {
  const { canonicalUrl: canonicalURL } = useCanonicalUrl();
  const latestCanonicalURL = useSyncedRef(canonicalURL);

  const { isAutoRefreshed, removeIsAutoRefreshed } = useIsAutoRefreshed();

  const pageViewData = useLatest({
    autoRefresh: isAutoRefreshed ? "Yes" : "No",
  });

  const trackPageView: TrackPageViewFunction = useCallback(
    data => {
      gtm.trackPageView({
        ...data,
        ...pageViewData.current,
        canonicalURL: latestCanonicalURL.current,
      });

      removeIsAutoRefreshed();
    },
    [pageViewData, latestCanonicalURL, removeIsAutoRefreshed],
  );

  const setTracking = useSetAtom(trackingAtom);
  useEffect(() => {
    setTracking({ trackPageView });
  }, [setTracking, trackPageView]);
};
